import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { formatDate, parseDate } from 'react-day-picker/moment';
import localeUtils from '../../../utils/localeUtils';
import 'react-day-picker/lib/style.css';
import { Form, Popup } from 'semantic-ui-react';

import AddButton from '../../../components/Button/AddButton';
import FilterButton from '../../../components/Button/FilterButton';

import { CardContainer, Title, Header, Footer, Main } from '../styles.js';

const initMalls = [{ key: '', value: '', text: 'Todos' }];
const initMotives = [{ key: '', value: '', text: 'Todos' }];

export default function Filter(props) {
  const { onClick, handleAdd, malls, errors, motives } = props;
  const [plate, setPlate] = useState('');
  const [type] = useState('');
  const [mall, setMall] = useState('');
  const [motive, setMotive] = useState('');
  const [fromDate, setFromDate] = useState(new Date());

  return (
    <CardContainer data-testid="filter-component">
      <Header>
        <Title data-testid="title-component">Buscar Listas Negras</Title>
      </Header>
      <Main>
        <Form>
          <Form.Group>
            <Popup
              mouseEnterDelay={500}
              mouseLeaveDelay={200}
              content="Fecha para la búsqueda"
              trigger={
                <span style={{ margin: '0 9px' }}>
                  <Form.Field
                    error={errors.begin_datetimeError}
                    label="Fecha de vigencia*"
                    control={DayPickerInput}
                    value={fromDate}
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    formatDate={formatDate}
                    parseDate={parseDate}
                    onDayChange={day => setFromDate(day)}
                    dayPickerProps={{
                      localeUtils: localeUtils, locale: 'es'
                    }}
                  />
                </span>
              }
            />
            <Form.Input
              label="Patente"
              placeholder="Patente"
              width={4}
              value={plate}
              onChange={(e, { value }) => setPlate(value)}
              className="plateInput"
            />
            <AddButton
              data-testid="add-button-component"
              add
              onClick={handleAdd}
            />
          </Form.Group>
          <Form.Group>
            <Form.Select
              data-testid="select-field"
              label="Centro Comercial"
              placeholder="Todos"
              options={[...initMalls, ...malls]}
              width={6}
              value={mall}
              onChange={(e, { value }) => setMall(value)}
            />
            <Form.Select
              label="Motivos"
              placeholder="Todos"
              options={[...initMotives, ...motives]}
              width={6}
              value={motive}
              onChange={(e, { value }) => setMotive(value)}
            />
          </Form.Group>
        </Form>
      </Main>
      <Footer>
        <FilterButton
          className="btnFilter"
          onClick={() => onClick(plate, type, mall, fromDate, motive)}
        />
      </Footer>
    </CardContainer>
  );
}

Filter.propTypes = {
  onClick: PropTypes.func,
  handleAdd: PropTypes.func,
  malls: PropTypes.array,
  motives: PropTypes.array,
  errors: PropTypes.object
};
